export default {
  nextLang: "English",
  banner_message: "للاستفسارات يرجى التواصل معنا على wecare@posrocket.com",
  catalog: "الفهرس",
  categories: "الفئات",
  items: "السلع",
  combos: "كومبو",
  email_address: "عنوان البريد الإلكتروني",
  email: "البريد الإلكتروني",
  enter_email: "ادخل البريد الإلكتروني",
  gender: "الجنس",
  enter_gender: "اختر الجنس",
  password: "كلمة المرور",
  sub_domain: "اسم العمل",
  remember_me: "تذكرني",
  reset_password: "إعادة تعيين كلمة المرور",
  back_to_login: "العودة إلى تسجيل الدخول",
  login: "تسجيل الدخول",
  invalid_email: "يرجى إدخال بريد إلكتروني",
  invalid_sub_domain: "يرجى إدخال اسم العمل",
  invalid_password: "يرجى إدخال كلمة المرور",
  fill_all_required_fields_message: "الرجاء إدخال كل الحقول الإجبارية",
  form_validation_error: "خطأ في التحقق من صحة البيانات",
  success_reset_title: "تم طلب إعادة تعيين كلمة المرور",
  success_reset_message: "تم إرسال كلمة مرور جديدة إلى بريدك الإلكتروني",
  auth_slider_text: "نقطة بيع تساعدك على البيع والنمو",
  menu: {
    catalog: "الفهرس",
    dashboard: "لوحة التحكم",
    today_orders: "طلبات اليوم",
    items: "السلع",
    reports: "التقارير",
    customers: "الزبائن",
    settings: "الإعدادات",
    business_settings: "اعدادت المتجر",
    account_settings: "إعدادات الحساب",
    logout: "تسجيل الخروج",
    orders: "الطلبات",
    categories: "الفئات",
    modifiers_list: "خيارات الطلب",
    combos: "الكومبو",
    recipes_book: "كتاب الوصفات",
    history: "جميع الطلبات",
    cash_and_payment: "النقد والمدفوعات",
    ooc_dashboard: "لوحة التحكم",
    ooc_login: "تسجيل الدخول",
    ooc_integration: "دمج",
    ooc: "OOC App",
    ooc_merchants: "التجار",
    communications: "التواصل",
    ooc_orders: "الطلبات",
    taxes: "الضرائب",
    extra_charge: "الرسوم الإضافية",
    cc_customers: "الزبائن",
    cc_dashboard: "لوحة التحكم",
    cc_items: "السلع",
    discounts: "الخصومات",
    currencies: "العملات"
  },
  footer: {
    about_us: "حولنا",
    email_us: "تواصل معنا",
    switch_lang: "English",
    copy_right_text: "جميع الحقوق محفوظة لدى شركة POSRocket ©  {year}",
  },
  create_customer: "إنشاء زبون جديد",
  edit_customer: "تعديل الزبون",
  actions: "إجراءات",
  select_locations: "الفرع",
  personal_information: "المعلومات الشخصية",
  additional_details: "التفاصيل الإضافية",
  address_details: "تفاصيل العنوان",
  add_first_primary_address: "أضف أول عنوان أساسي",
  no_address_found: "لم يتم العثور على عنوان",
  primary_address: "عنوان أساسي",
  primary: "أساسي",
  make_primary: "نحديد كأساسي",
  delete_address: "حذف العنوان",
  add_address: "إضافة العنوان",
  address_modal_title: "تفاصيل العنوان",
  optional_fields: "الحقول الاختيارية",
  add_address_label_name: "أضف تسمية للعنوان",
  select_city: "اختر مدينة",
  select_area: "اختر المنطقة",
  label: "التسمية",
  area: "المنطقة",
  city: "المدينة",
  residence: "السكن",
  building_villa: "بناء ، فيلا",
  select_street: "اختر الشارع",
  street: "الشارع",
  enter_floor_number: "أدخل رقم الطابق",
  floor_number: "رقم الطابق",
  enter_building_number: "أدخل رقم المبنى",
  building_number: "رقم المبنى",
  apartment_number: "رقم الشقة",
  enter_apartment_number: "أدخل رقم الشقة",
  back: " رجوع",
  current_location: "الموقع الحالي",
  search_on_map: "ابحث على الخريطة",
  primary_fields: "الحقول الأساسية",
  first_name: "الاسم الأول",
  enter_customer_first_name: "أدخل الاسم الأول",
  last_name: "اسم العائلة",
  enter_customer_last_name: "أدخل اسم العائلة",
  date_of_birth: "تاريخ الولادة",
  year: "السنة",
  month: "الشهر",
  day: "اليوم",
  add_another_phone_number: "أضف رقمًا آخر",
  customer_notes: "ملاحظات الزبون",
  add_notes_about_your_customer: "أضف ملاحظات عن الزبون",
  tags: "الأوسمة",
  discount_tag_label: "خصم من الأوسمة",
  discount_item_label: "الخصومات التلقائية على السلعة",
  tags_auto_complete_test: "أضف أوسمة للتصنيف",
  add_another_address: "أضف عنوانًا آخر",
  save: "حفظ",
  cancel: "إلغاء",
  primary_number: "الرقم الأساسي",
  delete_number: "حذف الرقم",
  source: "المصدر",
  first_name_required: "الاسم الأول إجباري",
  last_name_required: "اسم العائلة إجباري",
  enter_valid_email: "أدخل بريدًا إلكترونيًا صحيحًا",
  email_required: "البريد الإلكتروني إجباري",
  year_required: "السنة إجبارية",
  month_required: "الشهر إجباري",
  day_required: "اليوم إجباري",
  unspecified: "غير محدد",
  male: "ذكر",
  female: "أنثى",
  valid_phone_numbers: "تأكد من أن جميع أرقام الهواتف صحيحة",
  web_register: "لوحة ااتحكم",
  personal: "شخصي",
  default: "الافتراضي",
  edit: "تعديل",
  manage: "إدارة",
  customer_insights: "بيانات الزبون",
  customer_insights_with_name: "بيانات {customer} ",
  past_transactions: "الطلبات السابقة",
  timeline: "الجدول الزمني",
  wallet: "المحفظة",
  transactions: "الحركات",
  transaction: "حركة مالية",
  report: "التقارير",
  favorites: "المفضلة",
  loyalty_measure: "الولاء",
  history: "الطلبات السابقة ",
  show: "إظهار",
  everything: "كل شيء",
  comments_only: "التعليقات فقط",
  transaction_only: "الحركات فقط",
  item: "السلعة",
  quantity: "الكمية",
  price: "السعر",
  print: "طباعة",
  edit_address: "تعديل العنوان",
  success_copy_message: "تم النسخ بنجاح!",
  close: "إغلاق",
  updated_successfully: "تم تحديث البيانات بنجاح!",
  not_updated: "لم يتم تحديث البيانات بنجاح!",
  leave_changes_message: "لم تقم بحفظ التغييرات. هل أنت متأكد أنك تريد المغادرة دون حفظ؟",
  remove_selected_items_message: "هل أنت متأكد من حذف الصفوف المختارة؟",
  leave_changes_title: "هل تريد المغادرة؟",
  leave_title: "مغادرة",
  add_tag: "إضافة وسم",
  do_not_leave_title: "الاستمرار في التعديل",
  note_have_create_permission_message: "ليس لديك الإذن للإنشاء",
  created: "تم الإنشاء بنجاح",
  serial_number: "الرقم التسلسلي",
  location: "الفرع",
  sale_option: "خيار البيع",
  payment_method: "طرق الدفع",
  payment_status: "حالة السداد",
  time_to_end: "المدة",
  total_amount: "المجموع",
  column: "العمود",
  contain: "يحتوي",
  filter_input_placeholder: "ادخل قيمة التصفية",
  select_all: "اختر الكل",
  all_locations: "جميع الفروع",
  customer_create_message: "تم إنشاء الزبون بنجاح",
  customer_updated_message: "تم تعديل الزبون بنجاح",
  status: "الحالة",
  search_text_placeholder: "{placeholder}",
  search_on_ticket_number: "ابحث برقم التذكرة",
  search_orders_placeholder: "ابحث باسم الزبون، رقم هاتفه أو رقم طلبه",
  search_items_placeholder: "ابحث في السلع",
  search_customers_placeholder: "ابحث باسم الزبون أو رقم هاتفه",
  valid_phone_number: "رقم الهاتف الصحيح إجباري",
  primary_phone_number: "رقم الهاتف الأساسي",
  first_phone_number: "رقم الهاتف الأول",
  second_phone_number: "رقم الهاتف الثاني",
  third_phone_number: "رقم الهاتف الثالث",
  forth_phone_number: "رقم الهاتف الرابع",
  fifth_phone_number: "رقم الهاتف الخامس",
  page_count_string: "عدد الصفوف في الصفحة:",
  customer_name: "اسم الزبون",
  customer_phone: "رقم الهاتف",
  customer_tags: "الأوسمة",
  last_visit: "آخر زيارة",
  number_of_orders: "عدد الطلبات",
  amount_spent: "المبلغ المنفق",
  average_spend: "معدل الإنفاق للطلب الواحد",
  confirm_remove: "تأكيد الإزالة",
  button_delete_title: "حذف القيم المختارة",
  customer: "زبون",
  no_tags_found_message: "اضغط enter لإضافة وسم جديد",
  no_filters_found_message: "لم يتم تطبيق أي عامل تصفية",
  filters: "تصفية",
  add_filters: "أضف عامل تصفية",
  settings_location_link: "معلومات الفرع",
  settings_devices_link: "الأجهزة",
  settings_order_source_link: "مصدر الطلب",
  settings_sales_options_link: "خيارات البيع",
  deactivate_device: "إلغاء تنشيط الجهاز",
  settings_drivers_link: "السائقين",
  create_driver: "إضافة سائق",
  create_order_source: "إضافة مصدر للطلب",
  create_order: "إنشاء طلب",
  update_order_with_name: "تحديث الطلب ({name})",
  phone_number: "رقم الهاتف",
  driver_name: "اسم السائق",
  teams: "الفرق",
  locations: "الفروع",
  enter_driver_name: "أدخل اسم السائق",
  name_required: "الإسم إجباري",
  name: "الاسم",
  select_driver_working_team: "اختر فريق عمل السائق",
  create_sales_option: "إضافة خيار للبيع",
  create_new_team: " اضغط Enter لانشاء فريق جديد",
  enter_order_source_name: "أدخل اسم مصدر الطلب",
  extra_charge: "الرسوم الإضافية",
  type: "النوع",
  add_special_charge_per_location: "أضف رسوم إضافية مميزة لكل فرع",
  draft: "مسودة",
  queued: "قيد الإرسال",
  pending: "قيد الانتظار",
  dismissed: "مهمل",
  accepted: "مقبول",
  completed: "مكتمل",
  failed: "فاشل",
  in_planet_problem: "فاشل",
  canceled: "ملغى",
  rejected: "مرفوض",
  last_modified: "تاريخ اخر تعديل ",
  order_number: "رقم الطلب",
  agent: "الموظف",
  customer_number: "رقم هاتف الزبون",
  create_new_customer: "إضافة زبون جديد",
  search_customer: "ابحث في الزبائن",
  search_item: "ابحث في السلع",
  search_category: "ابحث في الفئات",
  select_variation: "اختر النوع",
  variations: "الأنواع",
  small: "صغير",
  medium: "وسط",
  large: "كبير",
  add_discount: "إضافة خصم",
  add_note: "أضف ملاحظة",
  notes: "ملاحظات الزبون",
  add_item_note_placeholder: "أضف ملاحظة لهذه السلعة",
  select_discount: "اختر الخصم",
  discount: "الخصم",
  customer_info: "معلومات الزبون",
  order_info: "معلومات الطلب",
  order_item: "طلب السلعة",
  order_items: "السلة",
  delivery: "توصيل",
  select_location: "اختر الفرع",
  delivery_time: "وقت الطلب",
  sales_option: "خيار البيع",
  charge_with_total: "تأكيد المبلغ {total}",
  confirm_order: " تاكيد الطلب ",
  not_allowed_order_message: "لا يمكن تعديل الطلب",
  building: "المبنى",
  villa: "فيلا",
  select_delivery_time: "اختر وقت الطلب",
  select_location_message: "اختر الفرع أولاً",
  most_popular: "الأكثر مبيعًا",
  customer_favorites: "مفضلة الزبون",
  all_categories: "جميع الفئات",
  select_modifier: "اختر لائحة التعديل ",
  modifier: "لائحة التعديل",
  no_items_selected: "السلة فارغة",
  call_center: "مركز الاتصال",
  call_center_orders_history: "سجل طلبات مركز الاتصال",
  leave_selected_customer_message_title: "تأكييد ازالة الزبون من الطلب",
  leave_selected_customer_message: "ستؤدي إزالة الزبون إلى إلغاء الطلب الحالي ، هل أنت متأكد أنك تريد الاستمرار؟",
  add_item: "إضافة سلعة",
  add: "إضافة",
  item_total: "مجموع قيمة السلعة",
  warning: "تحذير",
  message_user_not_selected: "قم بتعيين زبون اولا لبدء الطلب",
  message_no_items_found: "لا بوجد سلع في فرع {locationName}",
  message_already_added: "تمت إضافة السلعة مسبقًا",
  ok: "موافق",
  update: "تحديث",
  total: "المجموع",
  delivery_fees: "رسوم التوصيل",
  auto: "تلقائي",
  upload_image_label: "تحميل الصورة",
  uploaded_image: "تحميل الصورة",
  edit_image: "تعديل الصورة",
  delete_image_confirmation: " هل أنت متأكد أنك تريد حذف هذه الصورة من الفئة؟",
  delete_image_confirmation_title: "إزالة الصورة",
  delete: "حذف",
  open: "فتح",
  opened: "موافق",
  closed: "مكتمل",
  cancel_create_order_message: "أنت على وشك إلغاء الطلب الحالي. هل أنت متأكد أنك تريد الاستمرار؟",
  cancel_create_order_title: "تأكييد الغاء الطلب",
  cancel_update_order_title: "ترك تعديل الطلب",
  confirm_delete_order_message: "هل أنت متأكد من إلغاء هذا الطلب؟",
  confirm_delete_order_title: "تأكييد الغاء الطلب",
  button_delete_permanently_title: "تأكيد إلغاء الطلب",
  confirm_to_update_order_status_message: "هل أنت متأكد من إعادة الطلب إلى قيد الانتظار؟ ",
  confirm_to_update_order_status_title: "إعادة طلب هذا الطلب",
  confirm_to_update_order_status_action_title: "تأكيد",
  partially_refunded: "مردود جزئيًا",
  partially_paid: "مدفوع جزئيًا",
  voided: "ملغى",
  paid: "مدفوع",
  includes: "يشمل",
  excludes: "يستبعد",
  is_a: "هو",
  contains: "يتضمن",
  is_not_a: "ليس",
  is_more_than: "هو أكثر من",
  is_less_than: "هو أقل من",
  equals: "يساوي",
  calculate_tab: "احسب قيمة الطلب",
  tax: "ضريبة",
  taxes: "الضرائب",
  create_tab_button_title: "إرسال الطلب",
  create_tab_button_draft_title: "حفظ كمسودة",
  additional_comment: "ملاحظات اضافية",
  additional_comment_placeholder: "ملاحظات اضافية",
  order_created_success_message: "تم إرسال الطلب بنجاح",
  order_created_failed_message: "حدث خطأ: لم يتم إرسال الطلب بنجاح",
  order_saved_success_message: "تم حفظ الطلب كمسودة بنجاح",
  order_saved_error_message: "لم يتم حفظ الطلب كمسودة بنجاح",
  clear_basket_link_title: "تفريغ السلة",
  clear_order_basket_message: "أنت على وشك إزالة جميع السلع من هذه السلة. هل أنت متأكد أنك تريد الاستمرار؟",
  clear_order_basket_title: "تأكيد تفريغ السلة",
  clear_button_text: "تفريغ السلة",
  cancel_button_text: "إلغاء",
  favorite_order_option: "خيار الطلب المفضل",
  favorite_product: "المنتج المفضل",
  account_receivable: "الذمم",
  average_bill: "معدل قيمة الطلب",
  ave_bill: "قيمة الطلب",
  average_basket_size: "معدل حجم السلة",
  most_used_payment: "طريقة الدفع الأكثر استخدامًا",
  total_money_spent: "مجموع المال المنفق",
  discount_total: "مجموع الخصم",
  discount_name: "اسم الخصم",
  discount_details: "تفاصيل الخصم",
  total_items_count: "مجموع عدد السلع",
  number_of_visits: "عدد الزيارات",
  apply: "تأكيد",
  created_at: " الإنشاء",
  updated_at: "تم التعديل في",
  save_edit: "حفظ التعديلات",
  last_transaction: "آخر حركة",
  last_dine_in: "آخر زيارة للمطعم",
  last_delivery: "آخر طلب توصيل",
  create_new_category: "إنشاء فئة جديدة",
  local_name: "الاسم المحلي",
  display_name: "اسم العرض",
  category_taxes: "ضرائب الفئة",
  select_category_taxes: "اختر ضريبة للفئة",
  enter_item_name: "أدخل اسم السلعة",
  enter_item_local_name: "أدخل اسم السلعة المحلي",
  category_name_required: "اسم الفئة إجباري",
  category_create_message: "تم إنشاء الفئة بنجاح",
  category_updated_message: "تم تعديل الفئة بنجاح",
  category: "الفئة",
  assign_items_title: "تعيين سلع الى {categoryName} ",
  item_reassign_message: "سيتم إعادة تعيين السلع المختارة إلى هذه الفئة",
  item_reassign_message_sec: " سيتم تعيين السلع إلى فئة {categoryName} ",
  item_remove_message_title: "إزالة السلعة من {categoryName} ",
  item_remove_message: "هذه العملية ستزيل {itemName} من فئة {categoryName}. لن تنتمي هذه السلعة إلى أية فئة",
  remove: "حذف",
  assigned_items: "السلع المعينة",
  all_assigned_items: "جميع السلع المعينة ",
  date: "التاريخ",
  time: "الوقت",
  order_option: "خيار الطلب",
  net_sale: "صافي البيع",
  remaining_balance: "الحساب المتبقي",
  sold_by: "تم بيعها من قبل ",
  last_updated: "آخر تعديل",
  total_collected: "إجمالي التحصيل",
  extra_charges: "الرسوم الإضافية",
  refunds: "المبالغ المستردة",
  discounts: "الخصومات",
  failed_card_title: "الإرسال إلى الفرع",
  amount: "القيمة",
  end: "النهاية",
  start: "البداية",
  validity: "الصلاحية",
  days: "الأيام",
  rate: "النسبة",
  pending_status_tooltip_message: "لم يتم قبول الطلب أو رفضه من قبل الفرع حتى الآن",
  rejected_status_tooltip_message: "تم رفض الطلب من قبل الفرع",
  canceled_status_tooltip_message: "تم إلغاء طلب معلق أو من قبل الفرع بعد القبول",
  failed_status_tooltip_message: "لم يتم إرسال الطلب للفرع",
  all_statuses: "جميع الحالات",
  my_orders: "طلباتي",
  all_orders: "جميع الطلبات",
  no_status_selected_message: "لم يتم اختيار الحالة",
  image_preview: "image-preview",
  locations_search_placeholder: "البحث عن فرع",
  cities_search_placeholder: "البحث عن مدينة",
  selected_branches_with_number: "{branches} الفروع",
  selected_areas_description:
    "<b>{areasCount} المناطق المختارة</b> ستتوفر المواقع أدناه للفروع عند إنشاء طلب في مركز الاتصال",
  selected_area_description:
    "<b>{areasName}</b>  المنطقة سوف تحتوي على الفروع أدناه متاحة عند إنشاء طلب في مركز الاتصال",
  selected_branches_available_description: "سيتم تعيينها كمواقع متاحة",
  edit_available_branches_area: "  تعديل الفروع المتاحة للمنطقة",
  selected_branch_areas_description:
    "{branchName} المنطقة سوف تحتوي على الفروع أدناه متاحة عند إنشاء طلب في مركز الاتصال",
  set_branches_number: "تعيين {number} فروع",
  available_locations: "الفروع المتاحة",
  default_location: "الفرع الأساسي",
  set_empty_area_default: "تعيين الفرع الأساسي للمناطق الفارغة",
  edit_available_branch: "تعديل الفروع المتاحة",
  edit_default_branch: "تعديل الفرع الأساسي",
  set_available_branches: "تعيين الفروع المتاحة",
  selected_areas_with_number: "{areas} المناطق المختارة",
  no_locations: "لا يوجد فروع",
  tooltip_re_pending_status: "تحديث الحالة إلى معلق",
  currency_management: "إدارة العملات",
  payment_processors: "معالج الدفع",
  payment_methods: "طرق الدفع",
  payment_method_placeholder: "اختر طرق الدفع",
  void_reasons: "أسباب الإلغاء",
  pay_in_out: "المدفوعات / المصروفات",
  create_extra_charges: "إنشاء رسوم إضافية",
  create_extra_charge: "إنشاء رسوم إضافية",
  select_tax: "اختر الضريبة",
  applied_to: "تنتطبق على",
  select_order_options: "اختر طريقة الطلب",
  tax_name: "اسم الضريبة",
  extra_charge_name: "اسم الرسوم الإضافية",
  fixed: "ثابت",
  percentage: "نسبة",
  select_all_locations: "اختر جميع الفروع",
  edit_extra_charge: "تعديل الرسوم الإضافية",
  deleting_extra_charge_title: "حذف الرسوم الإضافية",
  delete_extra_charge_message:
    "حذف الرسوم الإضافية {extraChargeName} سيؤثر على خيار البيع\n    حيث أنه لن يكون هناك أية رسوم إضافية مرتبطة به\n    هل أنت متأكد أنك تود الاستمرار؟",
  delete_extra_charge: "حذف الرسوم الإضافية",
  delete_extra_charge_success: "تم حذف الرسوم الإضافية بنجاح",
  create_extra_charge_success: "تم انشاء الرسوم الإضافية بنجاح",
  update_extra_charge_success: "تم تعديل الرسوم الإضافية بنجاح",
  tax_required: "الضريبة إجبارية",
  rate_required: "النسبة إجبارية",
  valid_rate_required: "يجب ان تكون النسبة من ٤ خانات",
  location_required: "الفرع إجباري",
  apply_changes: "تطبيق التغيرات",
  edit_extra_charge_message:
    "لقد قمت بتغيير بعض القيم للرسوم الإضافية {extraChargeName}\n   هذا التغيير خطر و سوف يؤثر على الطريقة التي يتم احتساب التقارير بها.\n   لا يمكن التراجع عن هذه العملية، هل أنت متأكد أنك تود الاستمرار؟",
  tooltip_cancel_order: "إلغاء الطلب",
  tooltip_edit_order: "تعديل تفاصيل الطلب",
  tooltip_open_transaction_details: "عرض تفاصيل الحركة",
  tooltip_open_tags: "عرض تفاصيل الأوسمة",
  tooltip_my_orders: "إظهار طلباتي",
  tooltip_all_orders: "إظهار جميع الطلبات",
  tooltip_edit_customer: "تعديل الزبون",
  tooltip_open_insights: "عرض البيانات",
  tooltip_item_details: "تعديل تفاصيل الطلب",
  tooltip_basket_remove_item: "إزالة السلعة من السلة",
  tooltip_empty_basket: "تفريغ السلة",
  tooltip_open_discount_details: "إظهار تفاصيل الخصم",
  enter_item_price: "سعر السلعة",
  assign_tax: "تعيين الضريبة",
  assign_tax_message: "الرسوم الإضافية ستكون خاضعة لضريبة {tax_name} ",
  confirm: "تأكيد",
  others: "الأخرى",
  search_on_taxes_placeholder: "ابحث في الضرائب",
  address_label_with_index: "عنوان {index}",
  selected_locations_with_count: "{count} فروع",
  create_new_customer_hint: "اضغط إدخال لإضافة زبون جديد",
  override_auto_discount_confirm_message: "ستؤدي إضافة هذا الخصم إلى تجاوز الخصومات التلقائية. هل تريد المتابعة؟",
  of: "من",
  tooltip_order_details: "تفاصيل الطلب",
  order_details_ooc: "تفاصيل الطلب {orderName}",
  adding_discount_confirm_title: "إضافة خصم",
  adding_discount_confirm_message: "ستؤدي إضافة هذا الخصم إلى تجاوز الخصومات لكل سلعة. هل تريد المتابعة؟",
  yes: "نعم",
  order_with_name: "الطلب ({name})",
  message_no_transactions: "لا يوجد عمليات شراء سابقة لهذا الزبون",
  adding_discount_override_confirm_message: "ستؤدي إضافة هذا الخصم إلى تجاوز الخصومات التلقائية. هل تريد المتابعة؟",
  last_order: "آخر طلب",
  more_insights: "المزيد من البيانات",
  select_agent: "اختر الموظف",
  agents_search_placeholder: "ابحث باسم الموظف",
  no_agents: "لا يوجد موظفين",
  call_center_edit_order: "طلب تعديل مركز الاتصال",
  tooltip_reorder: "إعادة الطلب",
  reorder: "إعادة الطلب",
  customer_details: "معلومات الزبون",
  unlimited: "غير محدد المدة ",
  Open: "مفتوح",
  Busy: "مشغول",
  Closed: "مغلق",
  avenue: "جادة",
  block: "قطعة",
  select_avenue: "اختر جادة",
  select_block: "اختر قطعة",
  no_internet_message: "لا يوجد اتصال بالإنترنت",
  internet_back_message: "تم الاتصال بالإنترنت",
  total_bill: "كامل الطلب",
  any_item: "أية سلعة",
  specific_category: "فئات محددة",
  specific_item: "سلع محددة",
  edit_default_branch_modal_title: "تعديل الفرع الأساسي للمنطقة",
  edit_default_branch_areas_modal_title: "تعديل الفرع الافتراضي للمنطقة",
  default_branch_area_modal_description:
    "<b>{areaName} </b>المنطقة ستحتوي على الفرع أدناه كفرع أساسي من الفروع المتاحة عند إنشاء طلب على تطبيق مركز الاتصال",
  default_branch_areas_modal_description:
    "<b>{number} </b> مناطق ستحتوي على الفرع أدناه كفرع أساسي من الفروع المتاحة عند إنشاء طلب على تطبيق مركز الاتصال",
  default_branch_area_modal_disclaimer: "الفرع الأساسي المختار سيكون أساسي فقط للمناطق التي لديها هذا الفرع كفرع متاح",
  edit_empty_areas_modal_title: "تعيين الفرع الأساسي للمناطق الفارغة",
  edit_empty_areas_modal_message:
    "الفرع المختار أدناه سيكون الفرع الأساسي للعمل. عند إنشاء طلب على تطبيق مركز الاتصال لزبون بلا عنوان مضاف سيكون هذا الفرع هو الفرع الأساسي.",
  label_required: "التسمية مطلوبة",
  city_required: "المدينة مطلوبة",
  area_required: "المنطقة مطلوبة",
  residence_required: "الإقامة مطلوبة",
  avenue_required: "الجادة مطلوبة",
  block_required: "القطعة مطلوبة",
  datetime_error_title: "الوقت المختار غير صحيح",
  datetime_error_message: "الوقت الذي تم اختياره في الماضي، يرجى اختيار وقت بعد الوقت الحالي",
  datetime_error_button_title: "تم",
  extra_info: "معلومات إضافية",
  confirm_delivery_fees_error_title: "مبلغ رسوم التوصيل غير صالح",
  confirm_delivery_fees_error_message: "يرجى التحقق من قيمة مبلغ رسوم التوصيل",
  confirm_delivery_fees_button_title: "تحديد رسوم التوصيل",
  tax_exc: "ضريبة مضافة",
  tax_inc: "ضريبة مشمولة",
  delivery_note: "ملاحظات التوصيل",
  delivery_note_hint: "سيتم طباعة هذه الملاحظات على فاتورة التوصيل",
  all_week: "كل الأسبوع",
  access_denied_title: "الدخول غير مسموح ",
  access_denied_message: "نأسف! ليس لديك إذن للوصول إلى الصفحة المطلوبة",
  get_support_message: "إذا كنت بحاجة إلى مساعدة ، الرجاء التواصل مع",
  customer_support: "دعم العملاء",
  change_location_message: "تأكييد تغيير الفرع",
  change_location_title: "سيؤدي تغيير الفرع  إلى تفريغ السلة و تفاصيل الطلب، هل أنت متأكد أنك تريد الاستمرار؟",
  saved_successfully: "تم الحفظ بنجاح",
  something_went_wrong: "هناك خطأ ما",
  business_name: "اسم العمل",
  customer_id: "رقم العمل",
  country: "البلد",
  integrations: "التطبيقات",
  select_integrations_to_edit_the_menu: "حدد عمليات الدمج لتحرير القائمة",
  edit_menu_for: "تعديل قوائم الطعام لدى",
  menus: "قوائم الطعام",
  number_of_items: "عدد السلع ",
  number_of_integrations: "عدد التطبيقات",
  last_updated_by: "آخر تحديث بواسطة",
  add_menu: "إضافة قائمة",
  days_ago: "أيام مضت",
  menus_integration: "قوائم طعام التطبيقات",
  empty_state_order: "لا توجد طلبات سابقة لهذا الزبون",
  no_data: "لايوجد بيانات",
  no_orders_yet: "لا يوجد طلبات",
  type_your_message: "اكتب رسالتك",
  session_timeout: "الرجاء إعادة تسجيل الدخول",
  driver_phone: "رقم هاتف السائق",
  delete_customer: "حذف الزبون",
  delete_customers: "حذف الزبائن",
  CALLCENTER: "مركز الاتصال",
  REGISTER: "كاشير",
  DASHBOARD: "لوحة التحكم",
  TALABAT: "طلبات",
  refresh_merchants: "تحديث التجار",
  manage_menu: "التحكم بقوائم الطعام",
  Select_branch_to_edit_its_menus: "اختر الفرع الذي تريد تعديل قوائم الطعام لديه",
  menu_name: "اسم قائمة الطعام",
  available_items: "السلع المتاحة",
  active_integrations: "التطبيقات المفعلة",
  no_menus_yet: "لم يتم إنشاء قائمة طعام لهذا الفرع حتى الآن",
  menu_integrations: "تطبيقات قائمة الطعام",
  delete_menu: "حذف قائمة الطعام",
  deleting_menu_for: "حذف قوائم الطعام لدى ",
  merchant_menu_confirmation_delete_message: "   هل أنت متأكد من حذف <b> {name} </b> ",
  merchant_menu_confirmation_delete_title: "حذف قوائم الطعام لدى {branch}؟",
  delete_confirmation: " هل أنت متأكد من حذف",
  question_mark: "؟",
  menu_label: "قائمة الطعام ",
  integration_name: "اسم التطبيق",
  manage_menu_integrations: "التحكم بتطبيقات قائمة الطعام",
  next: "التالي",
  enable_all: "  تفعيل الجميع",
  cancel_menu_creation: "إلغاء إنشاء القائمة",
  you_will_lose_edits:
    "أنت على وشك إلغاء القائمة التي تقوم بإنشائها و ستفقد جميع العناصر المضافة إلى هذه القائمة. هل أنت متأكد أنك تريد الإلغاء؟",
  not_enabled_branch:
    "هذا الفرع غير مفعل على أية من التطبيقات. يرجى تحديث إعدادات التطبيقات لهذا العمل و المحاولة مجددًا",
  basic_information: "المعلومات الأساسية",
  edit_variation: "تحرير النوع",
  edit_modifier: "تحرير خيار التعديل",
  original_name: "الاسم الأصلي",
  original_local_name: "الاسم المحلي الأصلي",
  item_description: "وصف السلعة",
  item_local_description: "الوصف المحلي للسلعة",
  variation_name: " اسم النوع",
  variation_local_name: "  الاسم المحلي للنوع",
  variation_price: "سعر النوع",
  original_variation_price: "سعر النوع الأصلي",
  list_name: "اسم اللائحة ",
  list_local_name: "الاسم المحلي للائحة",
  original_price: "السعر الأصلي",
  add_menu_for: " إضافة قائمة طعام لـ",
  removing_category_from_menu: "حذف فئة من قائمة الطعام",
  removing_category_body:
    "أنت على وشك إزالة فئة {category_name}  من قائمة الطعام.<br><br> حذف هذه الفئة سيؤدي إلى خسارة جميع التعديلات التي تم إجراؤها على السلع فيها, هل تود المتابعة؟",
  remove_category: "حذف فئة من قائمة الطعام",
  save_item: "حفظ السلعة",
  save_variation: "حفظ النوع",
  save_modifiers_list: "حفظ لائحة تعديل السلع",
  quantity_allowed: "السماح بالكمية",
  business_id: "رقم العمل",
  modifiers_lists: "لوائح تعديل السلع",
  search_menus: "ابحث في قوائم الطعام",
  custom_menus_list: "قوائم الطعام المخصصة",
  main_menu: "القائمة الأساسية",
  original_categories: "الفئات الأصلية",
  leaving_edit_menu: "إلغاء تعديل قائمة الطعام",
  leaving_edit_menu_message:
    "أنت على وشك مغادرة عملية تعديل قائمة الطعام <b>{menuName}</b>.<br><br> ستخسر جميع التعديلات التي قمت بها. هل أنت متأكد من المغادرة؟",
  confirm_accept: "موافق ",
  category_name: " اسم الفئة",
  category_local_name: " الاسم المحلي للفئة",
  no_available_items: "عدد السلع المتاحة",
  item_name: "اسم السلعة ",
  item_local_name: "  الاسم المحلي للسلعة",
  search_area: "ابحث باسم المنطقة",
  search_customer_placeholder: "ابحث باسم الزبون أو رقم هاتفه",
  modifier_name: "اسم خيار التعديل ",
  modifier_local_name: "  الاسم المحلي لخيار التعديل",
  business_branch_menu: "قائمة طعام {branch_name}  {business_name}",
  no_modifiers_lists_available: "لا يوجد لوائح تعديل السلع لهذه السلعة",
  modifiers: "خيارات التعديل",
  single_option: "خيار واحد",
  multiple_options: "خيارات عديدة",
  note: "ملاحظة",
  orders_list: "قائمة الطلبات",
  order_id: "رقم الطلب",
  location_id: "رقم الفرع",
  created_at_label: "تاريخ الانشاء",
  location_name: "اسم الفرع ",
  order_name: "اسم الطلب",
  search_orders: "ابحث برقم الطلب",
  chat_empty_state: "اختر اسم الفرع للتواصل مع الفرع",
  merchants_list: "قائمة التجار",
  undefined_source: "المصدر غير معروف",
  selected_with_count: "{count} مختار",
  confirm_delete_customer_message: "أنت على وشك حذف {countTitle}. هل أنت متأكد أنك تريد الاستمرار؟",
  customers: "زبائن",
  search_original_categories: " ابحث في الفئات الأصلية",
  order_log: "سجل الطلب {orderName}",
  order_log_menu: "سجل الطلب",
  log_timeline: "الجدول الزمني للسجل",
  business_details: "عن المتجر",
  settings_business_details_link: "عن المتجر",
  address: "العنوان",
  business_contact_email: "ايميل للمتجر",
  no: "لا",
  creation_time: "وقت الانشاء",
  delete_customer_message: "هل انت متأكد انك تريد حذف هذا الزبون؟",
  delete_customer_title: "حذف الزبون",
  add_custom_item: "اضافة سلعة مخصصة",
  custom_amount_item: "بند المبلغ المخصص",
  validate_custom_item_price: "السعر إجباري",
  validate_custom_item_name: "الاسم إجباري",
  custom_item_name: "اسم السلعة المخصصة",
  submit: "يقدم",
  order_custom_item: "اسم السلعة المخصصة",
  extra_charge_price: "سعر الشحن الإضافي",
  custom: "مخصص",
  edit_custom_item: "تعديل سلعة مخصصة",
  parsed: "قيد الارسال",
  to: "الى",
  edit_tax_message:
    "لقد قمت بتغيير بعض القيم لضريبة {taxName}.\n   هذا التغيير خطر و سوف يؤثر على الطريقة التي يتم احتساب الضريبة فيها بكل السلع المرتبطة بها و في التقارير بها.\n   لا يمكن التراجع عن هذه العملية، هل أنت متأكد أنك تود الاستمرار؟",
  delete_tax_success: "تم حذف الضريبة بنجاح",
  create_tax_success: "تم انشاء الضريبة بنجاح",
  update_tax_success: "تم تعديل الضريبة بنجاح",
  deleting_tax_title: "حذف الضريبة",
  delete_tax_message:
    "أنت على وشك حذف ضريبة {taxName}.\n  هذا التغيير خطر و سوف يؤثر على كل السلع المرتبطة بهذه الضريبة و جميع التقارير.\n   لا يمكن التراجع عن هذه العملية، هل أنت متأكد أنك تود الاستمرار؟",
  delete_tax: "حذف الضريبة",
  create_tax: "إنشاء ضريبة",
  tax_type: "نوع الضريبة",
  additive: "مضافة",
  inclusive: "شاملة",
  select_tax_type: "اختر نوع الضريبة",
  add_tax: "إضافة ضريبة",
  tax_type_required: "نوع الضريبة إجباري",
  invalid: "غير صالح",
  edit_business_details: "تعديل معلومات المتجر",
  sender_email: "ايميل لخدمة العملاء",
  time_zone: "المنطقة الزمنية",
  business_currency: "العملة",
  end_of_business_day: "نهاية يوم العمل",
  rocket_uses_this_email: "ايميل للتواصل مع POSRocket",
  customers_use_this_email: "ايميل للتواصل مع الزبائن",
  enter_address: "ادخل العنوان",
  industry: "قطاع العمل",
  confirm_leave_edit_business_message: "أنت على وشك المغادرة قبل حغظ التعديلات. هل أنت متأكد أنك تريد الاستمرار؟",
  confirm_leave_edit_business_title: "الغاء التعديلات",
  business_name_setting: "اسم المتجر",
  search_driver_placeholder: "البحث عن اسم السائق او رقم الهاتف",
  add_driver: "اضافة سائق جديد",
  edit_driver: "تعديل السائق",
  delete_driver: "حذف السائق",
  edit_teams: "تعديل الفرق",
  driver_create_leave_message: "أنت على وشك المغادرة قبل اضافة السائق الجديد. هل أنت متأكد أنك تريد الاستمرار؟",
  driver_edit_leave_message: "أنت على وشك المغادرة قبل حغظ تعديلات السائق. هل أنت متأكد أنك تريد الاستمرار؟",
  driver_edit_leave_title: "الغاء التعديلات",
  driver_create_leave_title: "مغادرة اضافة سائق جديد",
  delete_confirmation_title: "تأكيد الحذف",
  delete_driver_message: "أنت على وشك حذف سائق. هل أنت متأكد أنك تريد الاستمرار؟",
  end_of_business_day_required: "نهاية يوم العمل اجباري",
  unselected_date_time: "غير محدد",
  service_charge: "الخدمات",
  OOCDelivery: "التوصيل",
  top_selling_items: " أكثر السلع مبيعًا",
  top_selling_areas: "أكثر المناطق مبيعًا",
  top_selling_agents: "أكثر المندوبين مبيعًا",
  orders_by_location: "الطلبات لكل موقع",
  total_orders: "مجموع الطلبات",
  average_net_sales_per_order: "متوسط صافي المبيعات للطلب",
  total_net_sales: "مجموع صافي المبيعات",
  average_order_time: "متوسط وقت الطلب",
  orders_per_day_per_status: "الطلبات اليومية لكل حالة",
  order_with_number: "{number} طلب",
  order_with_numbers: "{number} طلبات",
  average_minute_with_number: "معدل، {number} دقيقة",
  minute_with_number: "{number} دقيقة",
  quickest_serving_locations: " أسرع الفروع خدمة",
  months: "اشهر",
  days_name: "ايام",
  month_name: "شهر",
  previous: "السابق",
  welcome_user_name: "اهلا، {username}",
  coming_soon: "قـريـبــاً",
  search_driver_by_name: "ابحث باسم السائق",
  view_more: "عرض المزيد",
  number_of_enabled_items: "عدد السلع المفعلة",
  no_messages: "لا يوجد رسائل",
  customer_primary_address_title: "العنوان الأساسي",
  add_sale_option: "اضافة خيار للبيع جديد",
  sale_option_placeholder: "ابحث باسم خيار البيع",
  sale_option_name: "اسم خيار البيع",
  other: "خيار اخر",
  dine_in: "في الفرع",
  pick_up: "استلام",
  create_new_extra_charge: "اضغط Enter لإنشاء رسوم اضافية جديدة",
  special_extra_charges_per_location: "تخصيص رسوم اضافية لكل فرع بشكل منفصل",
  search_by_sales_option_name: "ابحث باسم خيار البيع",
  extra_charge_for_branch: " الرسوم الاضافية لفرع {name}",
  delete_order_option_message: " أنت على وشك حذف خيار البيع. هل أنت متأكد أنك تريد الاستمرار؟",
  leave_create_sales_option_message:
    "أنت على وشك المغادرة قبل اضافة خيار البيع الجديد. هل أنت متأكد أنك تريد الاستمرار؟",
  leave_edit_sales_option_message: "أنت على وشك المغادرة قبل حفظ تعديلات خيار البيع. هل أنت متأكد أنك تريد الاستمرار؟",
  enter_sales_option_name: "ادخل اسم خيار البيع",
  type_required: "النوع اجباري",
  edit_sales_option: " تعديل خيار البيع",
  new_sale_option: "خيار بيع جديد",
  create_sales_option_title: "انشاء خيار بيع",
  settings_units_link: "الوحدات",
  add_unit: "اضافة وحدة",
  add_new_unit: "اضافة وحدة",
  enter_unit_name: "ادخل اسم الوحدة",
  abbreviation: "اختصار الوحدة",
  abbreviation_required: "اختصار الوحدة اجباري",
  enter_unit_abbreviation: "ادخل اختصار الوحدة",
  unable_delete_unit: " لا يمكن حذف هذه الوحدة لانها مستخدمة حاليا ",
  edit_unit: "تعديل الوحدة",
  delete_unit_message: "هل أنت متأكد أنك تريد حذف هذه الوحدة؟",
  unit_create_leave_message: "أنت على وشك المغادرة قبل اضافة الوحدة الجديدة. هل أنت متأكد أنك تريد الاستمرار؟",
  unit_edit_leave_message: "أنت على وشك المغادرة قبل حغظ تعديلات الوحدة. هل أنت متأكد أنك تريد الاستمرار؟",
  unit_edit_leave_title: "الغاء التعديلات",
  unit_create_leave_title: " مغادرة اضافة وحدة جديدة",
  enter_rate: "ادخل نسبة الضريبة",
  rate_validation: "النسبة اجبارية",
  tax_create_leave_message: "أنت على وشك المغادرة قبل اضافة الضريبة الجديدة. هل أنت متأكد أنك تريد الاستمرار؟",
  tax_create_leave_title: "مغادرة اضافة ضريبة جديدة",
  tax_edit_leave_message: "أنت على وشك المغادرة قبل حفظ تعديلات الضريبة. هل أنت متأكد أنك تريد الاستمرار؟",
  tax_edit_leave_title: "الغاء التعديلات",
  rate_limit: "يجب ان تكون النسبة بين 0 و 100",
  amount_validation: "يجب ان تكون النسبة بين 0 و 9999999999999999",
  rate_integer: "يجب ان تكون النسبة عدد صحيح",
  price_validation: "السعر إجباري",
  edit_tax: "تعديل الضريبة",
  tax_number: "الرقم الضريبي",
  branch_location: "الموقع",
  branch_name: "اسم الفرع",
  amount_required: "المبلغ اجباري",
  search_on_extra_charges_placeholder: "إبحث عن الرسوم الإضافية",
  custom_variation_price_required: "السعر إجباري",
  customer_address_required: "عنوان الزبون إجباري",
  no_address_selected: "عنوان غير محدد",
  delete_sales_option: "حذف خيار البيع",
  leave__create_sales_option_title: "مغادرة اضافة خيار البيع الجديد",
  leave__edit_sales_option_title: "الغاء التعديلات",
  create_new_discount: "اضافة خصم جديد",
  delete_discount_confirm_title: "هل أنت متأكد من حذف الخصم!",
  delete_discount_confirm_message: "سيتم حذف الخصم نهائيا",
  delete_discount_success_success: "تم حذف الخصم بنجاح!",
  select_type: "اختر نوع الخصم",
  discount_amount: "قيمة الخصم",
  discount_automatic: "تطيق الخصم تلقائي",
  discount_after_tax: "تطبيق الخصم بعد اضافة الضريبة",
  discount_custom: "تحديد قيمة الخصم عند البيع",
  ANY_ITEM: "كل السلع",
  TOTAL_BILL: "الفاتورة كاملة",
  SPECIFIC_CATEGORY: "فئة محددة",
  SPECIFIC_ITEM: "سلعة محددة",
  schedule_discount: "جدولة الخصم",
  date_range: "تحديد فترة زمنية",
  specific_days: "تحديد ايام و اوقات من الفترة الزمنية",
  SUNDAY: "الأحد",
  MONDAY: "الاثنين",
  TUESDAY: "الثلاثاء",
  WEDNESDAY: "الاربعاء",
  THURSDAY: "الخميس",
  FRIDAY: "الجمعة",
  SATURDAY: "السبت",
  schedule_discount_text: " جدولة هذا الخصم ليكون صالحًا خلال فترة زمنية محددة أو أيام محددة او أوقات محددة",
  discount_type_required: "نوع الخصم اجباري",
  search_categories_placeholder: "البحث في الفئات",
  create_discount_success: "تم انشاء الخصم بنجاح",
  applied_required: "يجب اختيار على ماذا ينطبق هذا الخصم",
  edit_discount: "تعديل الخصم",
  automatic: "تلقائي",
  not_automatic: "غير تلقائي",
  discount_color: "لون الخصم",
  update_discount_success: "تم تعديل الخصم بنجاح",
  category_required: "الفئة اجبارية",
  item_required: "السلع اجبارية",
  search_for_city_label: "ابحث عن مدينة",
  search_for_area_label: "ابحث عن منطقة",
  search_for_avenue_label: "ابحث عن جادة",
  search_for_block_label: "ابحث عن قطعة",
  extra_charge_create_title: "مغادرة اضافة رسوم اضافية جديدة",
  extra_charge_create_message:
    "أنت على وشك المغادرة قبل اضافة الرسوم الاضافية الجديدة. هل أنت متأكد أنك تريد الاستمرار؟",
  extra_charge_edit_title: "الغاء التعديلات",
  extra_charge_edit_message: "أنت على وشك المغادرة قبل حغظ تعديلات الرسوم الاضافية. هل أنت متأكد أنك تريد الاستمرار؟",
  set_custom_item_tax: "تعيين ضريبة للسلع المخصصة",
  tax_custom_leave_message:
    "أنت على وشك المغادرة قبل حفظ تعديلات الضريبة للسلع المخصصة. هل أنت متأكد أنك تريد الاستمرار؟",
  is: "هو",
  search: "ابحث",
  add_to_team: "اضافة لفريق",
  remove_from_team: " ازالة من فريق",
  add_to_branch: "اضافة لفرع",
  remove_from_branch: " ازالة من فرع",
  enable: "تفعيل",
  disable: "الغاء التفعيل",
  delete_drivers_message: "أنت على وشك حذف {count} سائقين. هل أنت متأكد أنك تريد الاستمرار؟",
  discount_rate: "نسبة الخصم",
  validate_number_value: "يجب ان تكون قيمة الخصم رقم صحيح",
  validate_percent_number_value: "نسبة الخصم يجب ان تكون بين ال0 و 100",
  delete_order_option_message_secondary:
    "أنت على وشك حذف خيار البيع. هل تريد حذف خيار البيع من المتجر او تريد ازالته من الفروع المختارة؟",
  remove_from_branches: "ازالة من الفروع",
  total_orders_increase_tooltip:
    "مجموع الطلبات من {startDate} الي {endDate} \n زادت بنسبة {amount} مقارنة بالفترة السابقة",
  total_orders_decrease_tooltip:
    "مجموع الطلبات من {startDate} الي {endDate} \n قلت بنسبة {amount} مقارنة بالفترة السابقة",
  avg_net_sale_increase_tooltip:
    " متوسط صافي المبيعات للطلب من {startDate} الي {endDate} \n زادت بنسبة {amount} مقارنة بالفترة السابقة",
  avg_net_sale_decrease_tooltip:
    " متوسط صافي المبيعات للطلب من {startDate} الي {endDate} \n قلت بنسبة {amount} مقارنة بالفترة السابقة",
  total_net_sale_increase_tooltip:
    " مجموع صافي المبيعات  من {startDate} الي {endDate} \n  زادت بنسبة {amount} مقارنة بالفترة السابقة",
  total_net_sale_decrease_tooltip:
    " مجموع صافي المبيعات  من {startDate} الي {endDate} \n قلت بنسبة {amount} مقارنة بالفترة السابقة",
  average_order_time_increase_tooltip:
    " متوسط وقت الطلب  من {startDate} الي {endDate} \n زادت بنسبة {amount} مقارنة بالفترة السابقة",
  average_order_time_decrease_tooltip:
    " متوسط وقت الطلب  من {startDate} الي {endDate} \n قلت بنسبة {amount} مقارنة بالفترة السابقة",
  no_customers_found: "لا يوجد زبائن",
  no_areas_found: "لا يوجد مناطق",
  no_drivers_found: "لا يوجد سائقين",
  no_taxes_found: "لا يوجد ضرائب",
  no_discounts_found: "لا يوجد خصومات",
  no_extra_charges_found: "لا يوجد رسوم اضافية",
  add_to_team_message: "قم باختيار الفرق التي تود اضافة ال{count} سائق المحدد له",
  remove_from_team_message: "قم باختيار الفرق التي تود ازالة ال{count} سائق المحدد منه",
  add_to_branch_message: "قم باختيار الفروع التي تود اضافة ال{count} سائق المحدد له",
  remove_from_branch_message: " قم باختيار الفروع التي تود ازالة ال{count} سائق المحدد منه",
  enable_drivers_title: "تأكييد التفعيل",
  enable_drivers_message: "أنت على وشك تفعيل {count} سائق. هل أنت متأكد أنك تريد الاستمرار؟",
  disable_drivers_title: "تأكييد الغاء التفعيل",
  disable_drivers_message: "أنت على وشك الغاء تفعيل {count} سائق. هل أنت متأكد أنك تريد الاستمرار؟",
  enable_driver_message: "أنت على وشك تفعيل {count} سائق. هل أنت متأكد أنك تريد الاستمرار؟",
  disable_driver_message: "أنت على وشك الغاء تفعيل {count} سائق. هل أنت متأكد أنك تريد الاستمرار؟",
  no_of_drivers: "عدد السائقين",
  team_name: "اسم الفريق",
  enter_team_name: "أدخل اسم الفريق",
  delete_team: "حذف فريق",
  delete_team_message:
    "أنت على وشك حذف فريق لديه سائقين. سيؤدي هذا الى ازالة الفريق من السائقين, هل أنت متأكد أنك تريد الاستمرار؟",
  leave_edit_message: "أنت على وشك المغادرة قبل حغظ التعديلات. هل أنت متأكد أنك تريد الاستمرار؟",
  digital_menu: {
    title: "قائمة الطعام الرقمية",
    create_digital_menu: "إنشاء قائمة الطعام الرقمية",
    edit_digital_menu: "تعديل قائمة الطعام الرقمية",
    basic_info: "المعلومات الأساسية",
    header: "الرأس",
    footer: "الحاشية",
    business_name: "اسم الشركة أو المحل",
    upload_banner: "رفع صورة",
    upload_icon: "رفع الرمز",
    social_media: "وسائل التواصل الاجتماعي",
    facebook_link: "رابط الفيسبوك",
    instagram_link: "رابط الإنستجرام",
    phone_number: "رقم الهاتف",
    address: "العنوان",
    enter_address: "ادخل العنوان",
    email_address: "البريد الإلكتروني",
    enter_email_address: "ادخل البريد الإلكتروني",
    website_link: "رابط الموقع",
    enter_website_link: "ادخل رابط الموقع",
    next: "التالي",
    design: "التصميم",
    font_color: "الخط واللون",
    background_image: "صورة الخلفية",
    category_name: "اسم الفئة",
    item_name: "اسم السلعة",
    show_item_img: "عرض صورة السلعة",
    show_local_name: "عرض الاسم المحلي",
    modifier_desc: "الوصف و التعديلات",
    show_modifiers: "عرض التعديلات",
    show_item_desc: "عرض وصف السلعة",
    qr_code: "كود QR",
    qr_code_customization: "QR تصميم",
    background_color: "لون الخلفية",
    text_field: "عنوان",
    qr_code_color: "QR لون كود",
    share_menu: "رابط قائمة الطعام",
    download_qr_code: "تنزيل QR كود",
    copy_link: "انسخ الرابط",
    save: "حفظ",
    font_family: "نوع الخط",
    font_size: "حجم الخط",
    delete_title: "حذف قائمة الطعام الرقمية",
    delete_message: "أنت على وشك حذف قائمة الطعام الرقمية. هل أنت متأكد أنك تريد الاستمرار؟",
    deleted_successfully: "تم حذف قائمة الطعام الرقمية بنجاح",
    scan_placeholder_text: "امسح لعرض القائمة",
    leave_changes_message: "لم تقم بحفظ التغييرات. هل أنت متأكد أنك تريد المغادرة دون اكمال الخطوات؟",
  },
  receipt_footer: "هامش الفاتورة",
  no_receipt_footer: "لا يوجد هامش فاتورة",
  location_type: "نوع الفرع",
  working_days: "أيام العمل",
  enter_valid_url: "الصيغة المدخلة غير صحيحة",
  amount_rate: "القيمة/النسبة",
  advance_filter_clear: "حذف",
  filter: "تصفية",
  apply_filter: "تطبيق التصفية",
  clear_filter: "حذف الكل",
  enter_value: "ادخل القيمة",
  active: "مفعّل",
  in_active: "غير مفعّل",
  exchange_create_leave_message: "أنت على وشك المغادرة قبل إضافة العملة. هل أنت متأكد أنك تريد الاستمرار؟",
  exchange_create_leave_title: "مغادرة إضافة عملة جديدة",
  exchange_edit_leave_message: "أنت على وشك المغادرة قبل حفظ تعديلات العملة. هل أنت متأكد أنك تريد الاستمرار؟",
  exchange_edit_leave_title: "الغاء التعديلات",
  edit_exchange: "تعديل العملة",
  add_exchange: "إضافة عملة",
  edit_exchange_message: "أنت على وشك المغادرة قبل حفظ تعديلات العملة. هل أنت متأكد أنك تريد الاستمرار؟",
  create_exchange_success: "تم إنشاء العملة بنجاح",
  update_exchange_success: "تم تعديل العملة بنجاح",
  delete_exchange_message: "أنت على وشك حذف العملة. هل أنت متأكد أنك تريد الاستمرار؟",
  deleting_exchange_title: "حذف العملة",
  delete_exchange: "حذف العملة",
  delete_exchange_success: "تم حذف العملة بنجاح",
  add_new_exchange: "إضافة عملة جديدة",
  currency: "العملة",
  conversion_rate: "سعر الصرف",
  inverse: "سعر الصرف العكسي",
  currency_required: "العملة مطلوبة",
  conversion_rate_required: "سعر الصرف مطلوب",
  inverse_required: "سعر الصرف العكسي مطلوب",
  driver_deleted: "تم حذف السائق بنجاح",
  drivers_deleted: "تم حذف {count} سائقين بنجاح",
  driver_created_success: "تم اضافة السائق بنجاح",
  driver_edit_success: "تم تعديل السائق بنجاح",
  driver_exist: "هذا السائق مضاف مسبقا",
  add_payment_category: 'إنشاء فئة مدفوعات/مصروفات',
  edit_payment_category: 'تعديل فئة مدفوعات/مصروفات',
  category_type: "نوع الفئة",
  locations_label: "الموقع" ,
  payment_category_create_leave_message: "أنت على وشك المغادرة قبل اضافة الفئة الجديدة. هل أنت متأكد أنك تريد الاستمرار؟",
  payment_category_create_leave_title: "مغادرة اضافة فئة جديدة",
  payment_category_edit_leave_message: "أنت على وشك المغادرة قبل حغظ تعديلات الفئة. هل أنت متأكد أنك تريد الاستمرار؟",
  payment_category_edit_leave_title: "الغاء التعديلات",
  unable_delete_payment_category: "لا يمكن حذف هذه الفئة لانها مستخدمة حاليًا",
  delete_payment_category_message: "هل أنت متأكد أنك تريد حذف هذه الفئة؟",
  add_new_payment_category: "إضافة فئة جديدة",
  search_by_payment_category_name: "ابحث باسم الفئة",
  in: "مدفوعات",
  out: "مصروفات",
  delete_payment_category_success: "تم حذف الفئة بنجاح!",
  order_status: {
    DRAFT: "مسودة",
    REJECTED: "مرفوض",
    PENDING: "قيد الانتظار",
    CANCELED: "ملغى",
    CLOSED: "مكتمل",
    OPENED: "موافق",
    CALLCENTER: "مركز الاتصال",
  },
  the_tax: "الضريبة",
  set_custom_tax_successfully: "تم تعيين ضريبة للسلع المخصصة بنجاح",
  change_tax_message:
    " لقد قمت بتغيير بعض القيم لضريبة {tax_name} <br> <br>هذا التغيير خطر و سوف يؤثر على الطريقة التي يتم احتساب الضريبة فيها بكل السلع المرتبطة بها و في التقارير.<br> <br>لا يمكن التراجع عن هذه العملية، هل أنت متأكد أنك تود الاستمرار؟",
};
